import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";


export default function Footer({ noSidebar = false }) {
  return (
    <footer
      className="border-top py-4 mt-auto"
      style={{
        backgroundColor: 'var(--bg-primary)',
        position: 'relative',
        zIndex: 1000
      }}
    >
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
            <p className="mb-0 text-muted small">
              © 2026 FTG Finance Technologies GmbH. Alle Rechte vorbehalten.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
             
            
            <a
              href="https://fintogo.ai/impressum/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted small text-decoration-none me-3"
            >
              Impressum
            </a>
            <a
              href="https://fintogo.ai/agb/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted small text-decoration-none me-3"
            >
              AGB
            </a>
            <a
              href="https://fintogo.ai/datenschutz/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted small text-decoration-none me-3"
            >
              Datenschutz
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
